export default __webpack_public_path__ + "static/media/Cang-Jei's Laugh.f07720bf.jpg";